import { useProfile } from "../../../shared/hooks/useProfile";
import ProfileForm from "./ProfileForm";
import theme from "@shared/utils/themeColors";

export default function AccountSection() {
  const { user, isLoading, error } = useProfile();

  if (isLoading) {
    return (
      <div className="grow">
        <div className="p-6 space-y-6">
          <div className="animate-pulse space-y-8">
            <div className="h-8 bg-gray-200 rounded w-1/4"></div>
            <div className="space-y-4">
              <div className="h-4 bg-gray-200 rounded w-1/2"></div>
              <div className="h-4 bg-gray-200 rounded w-3/4"></div>
              <div className="h-4 bg-gray-200 rounded w-2/3"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="grow">
        <div className="p-6">
          <div className="text-center">
            <h3 className="mt-2 text-sm font-medium text-gray-900">
              Error loading profile
            </h3>
            <p className={`mt-1 text-sm ${theme.text.muted}`}>
              Please try again later.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="grow">
      {/* Profile Section */}
      <ProfileForm user={user} />
    </div>
  );
}
